export const LIMIT_OF_SELECTED_ITEMS = 5;
